import React, { useRef, useEffect, useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import "./CanvasModal.scss";

const COLORS = ["#000000", "#C0392B", "#2471A3", "#27AE60", "#E67E22"];

export function CanvasModal({ show, onClose, onSave, initialImage }) {
  const canvasRef  = useRef(null);
  const drawing    = useRef(false);
  const lastPos    = useRef(null);
  const [color,    setColor]    = useState("#C0392B");
  const [size,     setSize]     = useState(3);

  useEffect(() => {
    if (!show || !canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx    = canvas.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Al reabrir una anotación existente, recuperar lo dibujado antes.
    if (initialImage) {
      const img = new Image();
      img.onload = () => ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      img.src = initialImage;
    }
  }, [show, initialImage]);

  function getPos(e, canvas) {
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width  / rect.width;
    const scaleY = canvas.height / rect.height;
    const src = e.touches ? e.touches[0] : e;
    return {
      x: (src.clientX - rect.left) * scaleX,
      y: (src.clientY - rect.top)  * scaleY,
    };
  }

  function startDraw(e) {
    drawing.current = true;
    lastPos.current = getPos(e, canvasRef.current);
    e.preventDefault();
  }

  function draw(e) {
    if (!drawing.current) return;
    e.preventDefault();
    const canvas = canvasRef.current;
    const ctx    = canvas.getContext("2d");
    const pos    = getPos(e, canvas);
    ctx.strokeStyle = color;
    ctx.lineWidth   = size;
    ctx.lineCap     = "round";
    ctx.beginPath();
    ctx.moveTo(lastPos.current.x, lastPos.current.y);
    ctx.lineTo(pos.x, pos.y);
    ctx.stroke();
    lastPos.current = pos;
  }

  function endDraw() { drawing.current = false; lastPos.current = null; }

  function clearCanvas() {
    const canvas = canvasRef.current;
    const ctx    = canvas.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  function handleSave() {
    const dataUrl = canvasRef.current.toDataURL("image/png");
    onSave(dataUrl);
    onClose();
  }

  if (!show) return null;

  return (
    <div className="cvm__overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="cvm__modal">
        <div className="cvm__header">
          <span className="cvm__title">Anotar / Firmar</span>
          <div className="cvm__toolbar">
            {COLORS.map((c) => (
              <button
                key={c}
                className={`cvm__color-btn${color === c ? " active" : ""}`}
                style={{ background: c }}
                onClick={() => setColor(c)}
                type="button"
              />
            ))}
            <select
              className="cvm__size-select"
              value={size}
              onChange={(e) => setSize(Number(e.target.value))}
            >
              <option value={2}>Fino</option>
              <option value={4}>Medio</option>
              <option value={8}>Grueso</option>
            </select>
            <Button size="mini" basic type="button" onClick={clearCanvas}>
              <Icon name="eraser" /> Limpiar
            </Button>
          </div>
          <button className="cvm__close" onClick={onClose} type="button">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <canvas
          ref={canvasRef}
          width={800}
          height={500}
          className="cvm__canvas"
          onMouseDown={startDraw}
          onMouseMove={draw}
          onMouseUp={endDraw}
          onMouseLeave={endDraw}
          onTouchStart={startDraw}
          onTouchMove={draw}
          onTouchEnd={endDraw}
        />

        <div className="cvm__footer">
          <Button basic type="button" onClick={onClose}>Cancelar</Button>
          <Button primary type="button" onClick={handleSave}>
            <Icon name="check" /> Guardar anotación
          </Button>
        </div>
      </div>
    </div>
  );
}
